import React from "react";
import { Dashboard } from "../../../components";

export const DashboardPage = () => {
  return <Dashboard />;
};
